import { useQuery } from '@apollo/react-hooks';
import { ApolloError } from 'apollo-boost';
import { logoutAndRedirect } from '../../core/auth';

export const useQueryHook = (QUERY: any, variables?: any) => {
    const  { loading, error, data } = useQuery(QUERY, {
        // update(_, result) {
        //     console.log(result, 'result')
        // },
        onError({ graphQLErrors, networkError }: ApolloError) {
            console.log(graphQLErrors, 'graphQLErrors');
            graphQLErrors.map((eachError: any): void => {
                if(eachError?.statusCode === 401) {
                    logout();
                }
                const errorMessage = eachError.message.split(':');
                eachError.message = errorMessage[errorMessage.length > 1 ? 1 : 0];
                return null;
            });
        },
        onCompleted(result) {},
        variables: variables,
        fetchPolicy: 'network-only'
    });
    return {
        loading,
        error,
        data
    }
}

const logout = () => {
    logoutAndRedirect();
}